var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.6898 12.5719V28.4531C26.6898 29.3062 25.9961 30 25.143 30H10.8555C10.0023 30 9.30859 29.3062 9.30859 28.4531V7.54688C9.30859 6.69375 10.0023 6 10.8555 6H20.118L26.6898 12.5719Z",
    fill: "#E9EDF4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.1085 16.9987C24.1085 17.2871 23.9197 17.517 23.6831 17.517H12.3101C12.0767 17.517 11.8848 17.2871 11.8848 16.9987C11.8848 16.7104 12.0767 16.4805 12.3101 16.4805H23.6831C23.9197 16.4805 24.1085 16.7104 24.1085 16.9987Z",
    fill: "#D2DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.1085 19.655C24.1085 19.9434 23.9197 20.1733 23.6831 20.1733H12.3101C12.0767 20.1733 11.8848 19.9434 11.8848 19.655C11.8848 19.3666 12.0767 19.1367 12.3101 19.1367H23.6831C23.9197 19.1367 24.1085 19.3666 24.1085 19.655Z",
    fill: "#D2DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.19,
    d: "M21.0137 12.3234L26.6902 16.9219V12.6L23.4746 10.7344L21.0137 12.3234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.691 12.5719H21.666C20.8129 12.5719 20.1191 11.8781 20.1191 11.025V6L26.691 12.5719Z",
    fill: "#D2DBEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.6988 22.3851V27.1266C27.6988 27.6909 27.2646 28.1484 26.7289 28.1484H9.27068C8.73502 28.1484 8.30078 27.6909 8.30078 27.1266V22.3851C8.30078 21.8208 8.73502 21.3633 9.27068 21.3633H26.7289C27.2646 21.3633 27.6988 21.8208 27.6988 22.3851Z",
    fill: "#F14F4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.3281 22.7715H14.365C14.8111 22.7715 15.139 22.879 15.3593 23.0886C15.5797 23.2982 15.6925 23.5992 15.6925 23.9915C15.6925 24.3892 15.5743 24.7063 15.3325 24.932C15.0906 25.1577 14.7251 25.2706 14.2307 25.2706H13.5643V26.7432H12.3335V22.7715H12.3281ZM13.5589 24.4591H13.8598C14.0963 24.4591 14.2629 24.4161 14.3597 24.3355C14.451 24.2602 14.5048 24.142 14.5048 24.0184C14.5048 23.9001 14.4618 23.7873 14.3812 23.7013C14.3006 23.6153 14.1447 23.5723 13.9136 23.5723H13.5643L13.5589 24.4591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.3477 22.7715H18.1696C18.5297 22.7715 18.8199 22.8199 19.0403 22.9166C19.2552 23.008 19.4434 23.1531 19.5885 23.3358C19.7336 23.5239 19.8411 23.7389 19.9002 23.97C19.9647 24.2226 19.9969 24.4806 19.9969 24.7385C19.9969 25.1631 19.9486 25.491 19.8518 25.7221C19.7604 25.9424 19.6261 26.1466 19.4487 26.3079C19.2929 26.4584 19.1048 26.5659 18.8952 26.625C18.6587 26.6948 18.4115 26.7271 18.1642 26.7325H16.3477V22.7715ZM17.573 23.669V25.8349H17.874C18.132 25.8349 18.3093 25.8081 18.4222 25.7489C18.5404 25.6844 18.6264 25.577 18.6748 25.4533C18.7339 25.3136 18.7662 25.0825 18.7662 24.7654C18.7662 24.3462 18.6963 24.056 18.5619 23.9055C18.4276 23.7496 18.1965 23.6744 17.8794 23.6744L17.573 23.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M20.646 22.7715H23.6718V23.6206H21.8714V24.314H23.4085V25.1148H21.8714V26.7325H20.6406V22.7715H20.646Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PDF.61b84cf369f790ee417e3b2e9193ea16.svg";